export default __webpack_public_path__ + "locales/ko-KR/Profile.json?hash=6bd31864826a3dcb513f395321e74585";